import initialProject from 'helpers/projects/initialProject'

export default (manufacturerName, manufacturerSpecificCameraModels) =>
  ({
    ...initialProject(`${manufacturerName} Cameras`),
    manufacturerSpecificCameraModels,
    manufacturerSpecific: true
  })



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/projectWithManufacturerCameraModels.js